

exports.__esModule = true;

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _app = require('xo-models/src/app');

require('xo-ui-components/src/modal/directive');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var logFpti = function logFpti(tokenizedWalletMsbOfferModel, toState) {
    var currency = tokenizedWalletMsbOfferModel.currency,
        amount = tokenizedWalletMsbOfferModel.amount;


    _logger.$logger.info('tokenized_wallet', {
        from: 'msb_page',
        to: toState,
        context_id: _angular.$rootScope.token,
        context_type: 'EC-Token',
        msb_currency_code: currency,
        msb_amt: amount
    });
};

var POPUP_TIMEOUT = 1000;

exports['default'] = _squid.$Component.extend('$xoTokenizedWalletMsbDirective', {
    tag: 'msb-offer',
    template: _template2['default'],

    resolve: {
        models: function models() {
            return {
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                tokenizedWalletMsbOfferModel: _app.$TokenizedWalletMsbOfferModel.instance(_angular.$rootScope.token).retrieve()
            };
        }
    },

    actions: {
        closeModal: function closeModal() {
            this.showModal = false;
            logFpti(this.models.tokenizedWalletMsbOfferModel, 'process_msb');
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var _models = this.models,
                tokenizedWalletMsbOfferModel = _models.tokenizedWalletMsbOfferModel,
                tokenizedWalletInfoModel = _models.tokenizedWalletInfoModel;


            logFpti(tokenizedWalletMsbOfferModel, 'prepare_msb');
            this.showModal = true;
            // show animated popup with a delay
            (0, _angular.$timeout)(function () {
                _this.$element.find('.modal-dialog, .modal-overlay').addClass('tokenizedWalletMsbFadeIn');
            }, POPUP_TIMEOUT);

            this.brandName = tokenizedWalletInfoModel.brandName();
            var currency = tokenizedWalletMsbOfferModel.currency,
                amount = tokenizedWalletMsbOfferModel.amount;


            this.amount = (0, _squid.formatCurrency)(amount, currency);
            this.termsLink = tokenizedWalletInfoModel.getMsbDisclaimerLink();
            this.brandName = tokenizedWalletInfoModel.brandName();
        }
    }
});


_angular.$rootScope;

_angular.$timeout;

_squid.$Component;

_squid.formatCurrency;

_logger.$logger;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletMsbOfferModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-tokenization-info/msbOffer/directive.js
// module id = ./pages/xo-tokenization-info/msbOffer/directive.js
// module chunks = 0